module.exports = __webpack_public_path__ + "img/title2.29ea5aed.png";